import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'


const products = {
  firestorePath: '/pick-locations',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'pickLocations',
  statePropName: 'pickLocations',
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state, getters, mutations, actions
}

export default products